import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import homePage from '@/view/homePage'   //首页
import onlineRecycling from '@/view/onlineRecycling'   //在线回收
import sendSell from '@/view/sendSell'   //寄售帮卖
import deposit from '@/view/deposit'   //闲置寄存
import contactUs from '@/view/contactUs'   //联系我们
import cooperation from '@/view/cooperation'   //招商合作
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/index',
            name: 'Index',
            component: Index,
            props: route => ({ query: route.query.q })
        },
        {
            path: '/',  //默认启动homePage页面
            name: 'homePage',
            component: homePage,
            props: route => ({ query: route.query.q })

        },{
            path: '/onlineRecycling',  ///在线回收
            name: 'onlineRecycling',
            component: onlineRecycling,
            props: route => ({ query: route.query.q })
        },{
            path: '/sendSell',  //寄售帮卖
            name: 'sendSell',
            component: sendSell,
            props: route => ({ query: route.query.q })
        },{
            path: '/deposit',  //闲置寄存
            name: 'deposit',
            component: deposit,
            props: route => ({ query: route.query.q })
        },{
            path: '/contactUs',  //联系我们
            name: 'contactUs',
            component: contactUs,
            props: route => ({ query: route.query.q })
        },{
            path: '/cooperation',  //招商合作
            name: 'cooperation',
            component: cooperation,
            props: route => ({ query: route.query.q })
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js